import React, { useEffect, useState } from 'react';
import API from '../services/api';
import Sidebar   from '../components/AnalyticsSidebar';
import DataTable from '../components/DataTable';
import './_analytics.css';              // analytics split layout
import '../styles/Dashboard.css';       // reuse badges, modal, buttons, + sleek modal styles

const fmt = (v) => (v === undefined || v === null || v === '' ? '—' : v);

export default function StudentsTable() {
  const [rows, setRows] = useState([]);
  const [viewRow, setViewRow] = useState(null);

  useEffect(() => {
    (async () => {
      const hdr = { headers:{ Authorization:`Bearer ${localStorage.token}` } };
      const { data } = await API.get('/requests/admin', hdr);
      setRows(Array.isArray(data) ? data : []);
    })();
  }, []);

  const columns = [
    { header:'Date & Time', cell:r => new Date(r.dateTime).toLocaleString() },
    { header:'Name',        cell:r => r.name },
    { header:'ID',          cell:r => r.studentId },
    { header:'Reason',      cell:r => r.leaveFor },
    { header:'Status',      cell:r => <span className={`status-badge status-${r.status}`}>{r.status}</span> },
    { header:'Details',     cell:r => (
        <button className="view-btn" onClick={()=>setViewRow(r)}>View</button>
      )
    },
  ];

  return (
    <div className="split-layout">
      <Sidebar />

      <div className="table-wrapper">
        <h2>🎓 Students – All Leave Requests</h2>

        <DataTable
          columns={columns}
          rows={rows}
          searchKeys={['name','studentId','leaveFor','email','pickUpWith','vehicleNo']}
          dateKey="dateTime"
        />
      </div>

      {/* ===== Details modal (same sleek style as Gatekeeper) ===== */}
      {viewRow && (
        <div className="modal-overlay details-modal">
          <div className="modal sleek">
            <div className="modal-header details-header">
              <h3>Leave Request Details</h3>
              <button
                className="icon-close"
                onClick={() => setViewRow(null)}
                aria-label="Close"
                title="Close"
              >
                ×
              </button>
            </div>

            {/* Top summary strip */}
            <div className="summary-strip">
              <div className="summary-left">
                <div className="summary-title">
                  <span className="student-name">{fmt(viewRow.name)}</span>
                  <span className="chip-id">ID: {fmt(viewRow.studentId)}</span>
                </div>
                <div className="summary-sub">
                  {fmt(viewRow.email)}
                  {viewRow.hostelType ? (
                    <span className="chip-hostel">{viewRow.hostelType}</span>
                  ) : null}
                </div>
              </div>

              <div className="summary-right">
                <span className={`status-badge status-${viewRow.status}`}>{viewRow.status}</span>
              </div>
            </div>

            <div className="modal-body">
              <div className="kv-grid">
                <div className="kv">
                  <div className="k">Reason</div>
                  <div className="v prewrap">{fmt(viewRow.leaveFor)}</div>
                </div>

                <div className="kv">
                  <div className="k">Leaving With</div>
                  <div className="v">{fmt(viewRow.pickUpWith)}</div>
                </div>

                <div className="kv">
                  <div className="k">Transport</div>
                  <div className="v">{fmt(viewRow.transport)}</div>
                </div>

                <div className="kv">
                  <div className="k">Vehicle No</div>
                  <div className="v">{fmt(viewRow.vehicleNo)}</div>
                </div>

                <div className="kv">
                  <div className="k">Driver Name</div>
                  <div className="v">{fmt(viewRow.driverName)}</div>
                </div>

                <div className="kv">
                  <div className="k">Date &amp; Time</div>
                  <div className="v mono">
                    {new Date(viewRow.dateTime).toLocaleString()}
                  </div>
                </div>

                <div className="kv full">
                  <div className="k">Warden Comment</div>
                  <div className="v note prewrap">{fmt(viewRow.wardenComment)}</div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="close-btn" onClick={() => setViewRow(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
